
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 31 27"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.328 25.927c0 .926-.673 1.308-1.418.926l-8.045-4.15c-.242-.118-.447-.317-.613-.595a1.612 1.612 0 01-.252-.83V.983c0-.757.44-1.1 1.436-.587l8.84 4.558c.128.132.034-.774.052 20.974zm1.107-19.088l9.238 15.42-9.238-4.736V6.839zM31 7.16v18.767c0 .297-.08.537-.243.72-.161.185-.38.277-.657.277s-.548-.078-.813-.232l-7.628-3.918L31 7.16zm-.052-2.136c0 .036-1.479 2.526-4.436 7.468a6469.98 6469.98 0 01-5.2 8.68L14.566 9.884 20.171.5c.305-.517.93-.608 1.35-.392l9.359 4.808a.113.113 0 01.068.107z"}})])
          )
        }
      }
    